/* eslint-disable */
import setPaddingTop from '@/utils/client/setPaddingTop'
export default (_ctx: any) => {
  setPaddingTop()
}
